export const getSignInPath = (path: string) => {
  const signInPath =
    !path || path === '/' ? '/login' : `/login?after_sign_in=${path}`;

  return signInPath;
};
